module.exports = __webpack_public_path__ + "static/media/madomi-italia.00d68a6a.png";